const parser = (data) => {
  try {
    return JSON.parse(data);
  } catch (error) {
    return {};
  }
};
export const buildButtonData = (template, oldData) => {
  const buttonLink = parser(oldData?.buttonLink);
  const {
    buttonText,
    buttonNewTab,
    emojiEnabled,
    emoji,
    buttonIcon,
    buttonRadius,
    buttonSize,
  } = oldData;

  return {
    ...template,
    label: buttonText,
    newTab: buttonNewTab,
    icon: emojiEnabled ? emoji : buttonIcon,
    url: buttonLink || "",
    corners: buttonRadius,
    size: buttonSize || "medium",
  };
};
